// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"nY-z","tooltip":"oY-z","tooltipContent":"pY-z","orderStatusWrapper":"qY-z"};